import { getDetailQueryName, getDetailRouteId } from './utils';
const layerIdMask = new RegExp(/^[a-zA-Z0-9-]+$/);
export const buildFeatureRouteMappings = (tinkerConfig) => {
    return tinkerConfig.mapLayers.edges
        .filter((mapLayer) => {
        const layerId = mapLayer.node.nameId;
        if (!layerIdMask.test(layerId)) {
            console.error(`CONFIG - Layer ID "${layerId}" contains illegal characters.`);
            return false;
        }
        return true;
    })
        .map((mapLayer) => {
        const node = { ...mapLayer.node, nameId: mapLayer.node.nameId.replaceAll('-', '_') };
        return {
            layer: mapLayer.node.nameId,
            routeId: getDetailRouteId(node),
            queryDetail: getDetailQueryName(node),
        };
    });
};
//# sourceMappingURL=buildFeatureRouteMappings.js.map